import { Component } from '@angular/core';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { Parcours } from 'src/app/shared/models/services-aide-emploi/parcours';

@Component({
	selector: 'app-rapport-activite',
	templateUrl: './rapport-activite.component.html',
	styleUrl: './rapport-activite.component.scss'
})
export class RapportActiviteComponent {
	startDate: string;
	endDate: string;

	rapport: RapportLigne[] = [];

	parcours: Parcours[];

	rapportLoaded = false;

	rapportStatique = [
		{
			etp: 'Dupont Alice',
			dh: 'DH-2025-0042',
			villes: 'Lyon (69), Villeurbanne (69)',
			km: 124.5,
			faceAFace: '12h30'
		},
		{
			etp: 'Martin Jean',
			dh: 'DH-2025-0038',
			villes: 'Grenoble (38)',
			km: 98.2,
			faceAFace: '9h00'
		},
		{
			etp: 'Durand Claire',
			dh: 'DH-2025-0042',
			villes: 'Lyon (69)',
			km: 63.0,
			faceAFace: '7h45'
		},
		{
			etp: 'Bernard Paul',
			dh: 'DH-2025-0050',
			villes: 'Annecy (74), Rumilly (74)',
			km: 152.3,
			faceAFace: '14h10'
		}
	];

	isLoading = false;

	constructor(private facade: FacadeService, private logger: LogService) {}

	ngOnInit(): void {
		this.startDate = '2025-04-01';
		this.endDate = '2025-06-30';
	}

	chargerRapport(): void {
		// this.getParcours();
		// this.rapportLoaded = true;

		this.getRapport();
	}

	getRapport(): void {
		this.isLoading = true;
		this.rapportLoaded = false;
		this.rapport = []; // reset visuel avant le chargement

		this.facade.statistiqueService
			.getActivityReportSAEByDate(
				new Date(this.startDate).getTime(),
				new Date(this.endDate).getTime()
			)
			.subscribe({
				next: (rapport: RapportLigne[]) => {
					this.rapport = rapport;
					this.rapportLoaded = true;
					this.isLoading = false;
				},
				error: (err: ErrorResponse) => {
					this.facade.toastService.createHttpErrorToast(
						err.error.response ? err.error.response : '',
						err.status
					);
					this.logger.error(
						'' + err.status + ' ' + err.error.response ? err.error.response : ''
					);
					this.isLoading = false;
				},
				complete: () => {
					this.isLoading = false;
				}
			});
	}

	// Helper method
	convertMinutesToHHMM(minutes: number): string {
		const hours = Math.floor(minutes / 60);
		const mins = minutes % 60;
		return `${hours.toString().padStart(2, '0')}:${mins
			.toString()
			.padStart(2, '0')}`;
	}

	exportCSV(): void {
		const headers = [
			'ETP',
			'Service',
			'N° Demande DH',
			'Nombre A/R',
			'Villes',
			'Km'
		];
		const rows = this.rapport.map((r) => [
			r.etp,
			r.service,
			r.idDemandDH,
			r.nbrAR,
			`"${r.villes}"`, // pour protéger les virgules
			r.km.toString().replace('.', ',') // format FR
		]);

		const csvContent = [
			headers.join(';'),
			...rows.map((row) => row.join(';'))
		].join('\n');

		const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
		const link = document.createElement('a');
		link.href = URL.createObjectURL(blob);
		link.download = `rapport_activite_${this.startDate}_${this.endDate}.csv`;
		link.click();
	}

	exportPDF(): void {
		const doc = new jsPDF();

		doc.setFontSize(14);
		doc.text('Rapport d’activité', 14, 15);
		doc.setFontSize(11);
		doc.text(
			`Période : du ${this.formatDate(this.startDate)} au ${this.formatDate(
				this.endDate
			)}`,
			14,
			22
		);

		autoTable(doc, {
			startY: 28,
			head: [['ETP', 'Service', 'N° Demande DH', 'Nombre A/R', 'Villes', 'Km']],
			body: this.rapport.map((r) => [
				r.etp,
				r.service,
				r.idDemandDH,
				r.nbrAR,
				r.villes,
				r.km.toFixed(2).replace('.', ',')
			]),
			styles: { fontSize: 10 }
		});

		doc.save(`rapport_activite_${this.startDate}_${this.endDate}.pdf`);
	}

	formatDate(date: string): string {
		const d = new Date(date);
		return d.toLocaleDateString('fr-FR');
	}
}

type RapportLigne = {
	etp: string;
	service: string;
	idDemandDH: string;
	nbrAR: number;
	villes: string;
	km: number;
	faceAFaceHHMM: string;
};

// type RapportEntry = {
// 	etp: string;
// 	dh: string;
// 	villes: string;
// 	km: number;
// 	faceAFace: string;
// };

// type RapportInterne = {
// 	etp: string;
// 	dh: string;
// 	villes: Set<string>;
// 	km: number;
// 	faceAFaceMinutes: number;
// };
